import React, { useState } from 'react'

import clsx from 'clsx'

import { ReactComponent as IconCampaign } from '../../static/svg/icon_campaign.svg'
import ReportErrorModal from '../ReportErrorModal'

import './ReportErrorButton.sass'

const ReportErrorButton = ({ onSubmit, showControls }) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false)
  
  const handleOpenDrawer = () => {
    setIsDrawerOpen(true)
  }

  const handleSubmit = (reportData) => {
    if (onSubmit) {
      onSubmit(reportData)
    }
  }

  return (
    <>
      <button
        className={clsx('ReportErrorButton', {
          'ReportErrorButton--elevated': showControls
        })}
        onClick={handleOpenDrawer}
      >
        <IconCampaign fill='#4b4b4b' />
        <span className='ReportErrorButton__text'>Reportar erro</span>
      </button>

      <ReportErrorModal
        open={isDrawerOpen}
        setOpen={setIsDrawerOpen}
        onSubmit={handleSubmit}
      />
    </>
  )
}

export default ReportErrorButton
